import React from "react";
import { Star } from "lucide-react";
import { useOpenStatus } from "../hooks/useOpenStatus";
import { BRAND } from "../mock";

const shortDay = (d) => (d === "Today" || d === "Tomorrow" ? d : (d ? d.slice(0, 3) : ""));

// Detour-style single line: ★ 4.6 · 340+ reviews · Open now · until 2 AM
export default function RatingStatus({ className = "" }) {
  const { isOpen, closesAt, reopenDay, reopenTime } = useOpenStatus();

  return (
    <a
      href={BRAND.social.google}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex flex-wrap items-center gap-x-2 gap-y-1 border border-nala-gold/30 bg-nala-charcoal/60 rounded-full px-4 py-2 text-sm text-nala-cream hover:border-nala-gold/60 transition-colors ${className}`}
    >
      <span className="inline-flex items-center gap-1.5">
        <Star size={14} className="fill-nala-gold text-nala-gold" />
        <span className="font-medium">{BRAND.rating}</span>
      </span>
      <span className="text-nala-cream-muted">· {BRAND.reviewCount} reviews</span>
      <span className="text-nala-cream-muted">·</span>
      {isOpen ? (
        <span className="inline-flex items-center gap-1.5">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-green-400" />
          </span>
          <span className="text-green-300 font-medium">Open now</span>
          <span className="text-nala-cream-muted">· until {closesAt}</span>
        </span>
      ) : (
        <span className="inline-flex items-center gap-1.5">
          <span className="inline-flex h-2 w-2 rounded-full bg-red-500" />
          <span className="text-red-300 font-medium">Closed</span>
          {reopenDay && (
            <span className="text-nala-cream-muted">· Opens {shortDay(reopenDay)} {reopenTime}</span>
          )}
        </span>
      )}
    </a>
  );
}
